export const OnboardingIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <path
        d="M9,7.5H7.059A6.059,6.059,0,0,0,1,13.558v4.988c0,1.5.662,2.218,1.97,2.937a.059.059,0,0,1,.03.051V23.5H9Z"
        fill="#c4f0eb"
      />
      <path
        d="M8,7.5H7.059A6.059,6.059,0,0,0,1,13.558v4.988c0,1.5.662,2.218,1.97,2.937a.059.059,0,0,1,.03.051V23.5"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M8,18.824V22.5a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1V1.5a1,1,0,0,0-1-1H17.95a.5.5,0,0,0-.49.4,2,2,0,0,1-3.92,0,.5.5,0,0,0-.49-.4H9a1,1,0,0,0-1,1V18.824Z"
        fill="#00e6ca"
      />
      <path
        d="M15.5,2.5A2,2,0,0,1,13.54.9a.5.5,0,0,0-.49-.4H9a1,1,0,0,0-1,1v21a1,1,0,0,0,1,1h6.5Z"
        fill="#c4f0eb"
      />
      <path
        d="M13.782,15.4l3.259,1.214,2-1.364a1.109,1.109,0,0,1,.876-.168,1.189,1.189,0,0,1,.852.766,1.106,1.106,0,0,1,.066.378,1.175,1.175,0,0,1-.548,1.018l-6.762,4.2a.415.415,0,0,1-.458-.013l-2.479-1.74a.229.229,0,0,1-.035-.322.234.234,0,0,1,.039-.038l1.04-.918a.231.231,0,0,1,.222-.038l1.3.777,1.653-1.154L12.4,16.5"
        fill="#f8fafc"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8,18.824V22.5a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1V1.5a1,1,0,0,0-1-1H17.95a.5.5,0,0,0-.49.4,2,2,0,0,1-3.92,0,.5.5,0,0,0-.49-.4H9a1,1,0,0,0-1,1v11"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10.25,7a.25.25,0,1,1-.25.25A.25.25,0,0,1,10.25,7"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.75,7a.25.25,0,1,1-.25.25A.25.25,0,0,1,12.75,7"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M15.25,7a.25.25,0,1,1-.25.25A.25.25,0,0,1,15.25,7"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M17.75,7a.25.25,0,1,1-.25.25A.25.25,0,0,1,17.75,7"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M20.25,7a.25.25,0,1,1-.25.25A.25.25,0,0,1,20.25,7"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7,19.467A3.2,3.2,0,0,0,9,16.5h2.847a2.108,2.108,0,0,0,2.133-1.709A2,2,0,0,0,12,12.5H6.5"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#c4f0eb"
      />
    </svg>
  );
};
